export function mapGetProductsToResponse(products: any): any {
  // Handle both nodes and edges patterns for backward compatibility
  const productList =
    products?.nodes || products?.edges?.map((edge: any) => edge.node) || [];

  // Process each product to flatten nested edges/node structures
  const response = productList.map((product: any) => {
    return {
      ...product,
      // Flatten variants - convert from edges/node to direct array
      variants:
        product.variants?.nodes ||
        product.variants?.edges?.map((edge: any) => edge.node) ||
        [],
      // Flatten images - convert from edges/node to direct array
      images:
        product.images?.nodes ||
        product.images?.edges?.map((edge: any) => edge.node) ||
        [],
      // Flatten collections - convert from edges/node to direct array
      collections:
        product.collections?.nodes ||
        product.collections?.edges?.map((edge: any) => edge.node) ||
        [],
    };
  });

  return response;
}

export function mapGetProductToResponse(product: any): any {
  // Process each product to flatten nested edges/node structures
  return {
    ...product,
    // Flatten variants - convert from edges/node to direct array
    variants:
      product.variants?.nodes ||
      product.variants?.edges?.map((edge: any) => edge.node) ||
      [],
    // Flatten images - convert from edges/node to direct array
    images:
      product.images?.nodes ||
      product.images?.edges?.map((edge: any) => edge.node) ||
      [],
    // Flatten collections - convert from edges/node to direct array
    collections:
      product.collections?.nodes ||
      product.collections?.edges?.map((edge: any) => edge.node) ||
      [],
  };
}
